import { IniInfo } from "system/types/interfaces";
import { parseConfigLine } from "./configValueQuoting";

// Commenting renders the four fields back into one line; uncommenting reads them out again.
// parseConfigLine recovers all four, so the round trip is lossless for a well formed line.

export const toCommentRow = (row: IniInfo): IniInfo => {
  const content = [row.name, row.value, row.delimiter, row.applicability].filter((part) => part && part.trim()).join(" ");
  const withInline = row.inlineComment ? `${content} ;${row.inlineComment}` : content;

  return {
    ...row,
    isComment: true,
    name: `-comment-${row.id}`,
    value: `;${withInline.replace(/\s+/g, " ").trim()}`,
    delimiter: "",
    applicability: "",
    inlineComment: "",
    pendingChanges: true,
  };
};

// Returns null when the comment text cannot be read back as a configuration, which is the same
// condition the row uses to disable its uncomment button.
export const fromCommentRow = (row: IniInfo): IniInfo | null => {
  const parsed = parseConfigLine(row.value ?? "");
  if (!parsed) return null;

  return {
    ...row,
    isComment: false,
    name: parsed.name,
    value: parsed.value,
    delimiter: parsed.delimiter,
    applicability: parsed.applicability,
    inlineComment: parsed.inlineComment,
    pendingChanges: true,
  };
};

export const toggleCommentRow = (row: IniInfo, isComment: boolean): IniInfo | null =>
  isComment ? fromCommentRow(row) : toCommentRow(row);
